import React from "react";
import cardImg01 from "../assets/who-we-are.png";
import cardImg02 from "../assets/our-mission.png";
import cardImg03 from "../assets/our-vision.png";

const AboutUs = () => {
  return (
    <>
      <section id="aboutus" className="container-fluid container-aboutus">
        <div className="section-width">
          <div className="section-title-wrapper">
            <h5 className="section-title text-center">About Us</h5>
          </div>
          <div className="section-content-wrapper">
            <div className="card border-0 card--aboutus">
              <div className="card-content--wrapper">
                <div classname="col-md-5">
                  <img
                    src={cardImg01}
                    className="img-fluid rounded-start card--aboutus__image"
                    alt="gayatri-home-tuition-who-we-are"
                  />
                </div>
                <div className="col-md-7">
                  <h5 className="card-title card-title--aboutus">Who We are</h5>
                  <p className="card-text card-text--aboutus">
                    At <strong>Gayatri Home Tuition</strong>, we believe that every child has the
                    potential to succeed with the right guidance and support.
                    With years of experience in personalized tutoring, we
                    provide quality home-based education tailored to each
                    student’s learning style and academic needs. Our trusted and
                    qualified tutors focus on building strong fundamentals,
                    boosting confidence, and ensuring consistent progress.
                    Whether it's school exams or concept clarity, we are here to
                    make learning easy, effective, and stress-free. Your child’s
                    success is our mission.
                  </p>
                </div>
              </div>
            </div>

            <div className="card border-0 card--aboutus">
              <div className="card-content--wrapper col-reverse">
                <div className="col-md-7">
                  <h5 className="card-title card-title--aboutus">
                    Our Mission Statement
                  </h5>
                  <p className="card-text card-text--aboutus">
                    At <strong>Gayatri Home Tuition</strong>, we believe that every child has the
                    potential to succeed with the right guidance and support.
                    With years of experience in personalized tutoring, we
                    provide quality home-based education tailored to each
                    student’s learning style and academic needs. Whether it's
                    school exams or concept clarity, we are here to make
                    learning easy, effective, and stress-free. Your child’s
                    success is our mission.
                  </p>
                </div>
                <div classname="col-md-5">
                  <img
                    src={cardImg02}
                    className="img-fluid rounded-start card--aboutus__image"
                    alt="gayatri-home-our-mission"
                  />
                </div>
              </div>
            </div>

            <div className="card border-0 card--aboutus">
              <div className="card-content--wrapper">
                <div classname="col-md-5">
                  <img
                    src={cardImg03}
                    className="img-fluid rounded-start card--aboutus__image"
                    alt="gayatri-home-our-vission"
                  />
                </div>
                <div className="col-md-7">
                  <h5 className="card-title card-title--aboutus">
                    Our Vision Statement
                  </h5>
                  <p className="card-text card-text--aboutus">
                    At <strong>Gayatri Home Tuition</strong>, we envision a world where every
                    learner is empowered to reach their fullest potential—fueled
                    by curiosity, confidence, and a lifelong passion for
                    knowledge. Through personalized guidance, innovative
                    teaching, and a nurturing environment, we aspire to
                    cultivate not just academic excellence, but well-rounded
                    individuals ready to thrive in an ever-evolving world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default AboutUs;
